import { checkIfSessionIsOrWillExpired } from "user/tools/common"

export function getBaseUrl(): string {
  checkIfSessionIsOrWillExpired()
  return `${window.location.protocol}//${window.location.host}`
}
